import script from "./TrainerProcesses.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainerProcesses.vue?vue&type=script&setup=true&lang=js"

import "./TrainerProcesses.vue?vue&type=style&index=0&id=793f32f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-793f32f0"]])

export default __exports__